import { SectionHead, Reveal, Crosshair } from "./Reveal";
import { useLang } from "../../i18n/LanguageContext";

export const CapitalGroup = () => {
  const { t } = useLang();
  return (
    <section id="ecosystem" className="relative overflow-hidden bg-ink bp-grid-dark py-24 sm:py-32" data-testid="capital-section">
      <Crosshair className="top-6 left-6" />
      <Crosshair className="top-6 right-6" />
      <Crosshair className="bottom-6 left-6" />
      <Crosshair className="bottom-6 right-6" />
      <div className="mx-auto max-w-[1440px] px-5 sm:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-end">
          <div className="lg:col-span-7">
            <SectionHead dark eyebrow={t.capital.eyebrow} title={t.capital.title} desc={t.capital.desc} testid="capital" />
          </div>
          <div className="lg:col-span-5">
            <div className="grid grid-cols-1 gap-px bg-[#f8f7f4]/15 border border-[#f8f7f4]/15">
              {t.capital.points.map((p, i) => (
                <Reveal key={p.label} delay={i * 0.1} className="bg-ink p-6 flex items-center justify-between gap-4">
                  <span className="font-display text-2xl sm:text-3xl font-black tracking-tight text-[#f8f7f4]">{p.val}</span>
                  <span className="font-mono-tech text-[10px] uppercase tracking-[0.2em] text-[#f8f7f4]/50 text-right">
                    {p.label}
                  </span>
                </Reveal>
              ))}
            </div>
          </div>
        </div>
        <Reveal delay={0.15} className="mt-14">
          <p className="font-mono-tech text-[10px] uppercase tracking-[0.3em] text-[#e63946]">{t.capital.partnersLabel}</p>
          <p className="mt-3 max-w-2xl text-sm leading-relaxed text-[#f8f7f4]/55">{t.capital.designLine}</p>
          <div className="mt-5 flex flex-wrap gap-2.5">
            {t.capital.partners.map((p) => (
              <a
                key={p.url}
                data-testid={`partner-link-${p.label.replace(/[^a-z]/g, "-")}`}
                href={p.url}
                target="_blank"
                rel="noopener noreferrer"
                className="chamfer-sm border border-[#f8f7f4]/20 px-4 py-2 font-mono-tech text-[11px] tracking-[0.15em] text-[#f8f7f4]/70 transition-colors duration-200 hover:border-[#e63946] hover:text-[#f8f7f4]"
              >
                {p.label}
                {p.role && (
                  <span className="block mt-1 text-[9px] tracking-[0.12em] text-[#f8f7f4]/40">{p.role}</span>
                )}
              </a>
            ))}
          </div>
        </Reveal>
        <Reveal delay={0.2} className="mt-16">
          <p className="font-mono-tech text-[10px] uppercase tracking-[0.3em] text-[#f8f7f4]/35">
            MGT-GROUP / CELL — PACK — VEHICLE — GRID
          </p>
        </Reveal>
      </div>
    </section>
  );
};
